<template>
    <div class="px-6 py-4 border-b border-gray-400 dark:border-gray-700">
      <div class="grid grid-cols-4 gap-4 lg:gap-6">
        <div
          v-for="(item, i) in parametros"
          :key="i"
          :class="[(item.tipo?.comaNombrecorto == 'TEXTAREA' ? 'col-span-4' : '' ),'mb-4 sm:mb-8']"
        >
          <InputDefault
            v-if="item.tipo?.comaNombrecorto == 'TEXT'"
            v-model="item.valor"
            :label="item.cdjpLabel"
            type="text"
          ></InputDefault>
          <SelectDefault
            v-else-if="item.tipo?.comaNombrecorto == 'LISTA'"
            v-model="item.valor"
            :label="item.cdjpLabel"
            option-text="optionText"
            option-value="optionValue"
            :options="item.lista"
          >
          </SelectDefault>
          <SelectDefault
            v-else-if="
              item.tipo?.comaNombrecorto == 'LISTA_SQL' ||
              (item.cdjpConsulta && !item.cdjpValor)
            "
            v-model="item.valor"
            :label="item.cdjpLabel"
            option-text="optionText"
            option-value="optionValue"
            :options="item.lista"
            placeholder="Selecciona una opción..."
          >
          </SelectDefault>
          <TextareaDefault
            v-else-if="item.tipo?.comaNombrecorto == 'TEXTAREA'"
            v-model="item.valor"
            :label="item.cdjpLabel"
          />
          <InputDefault
            v-else-if="item.tipo?.comaNombrecorto == 'FECHA'"
            v-model="item.valor"
            :label="item.cdjpLabel"
            type="date"
          ></InputDefault>
          <SwitchDefault
            v-else-if="item.tipo?.comaNombrecorto == 'SI/NO'"
            v-model="item.valor"
            :label="item.cdjpLabel"
            true-value="true"
            false-value="false"
          ></SwitchDefault>
          <!-- Fallback para tipos no reconocidos -->
          <div v-else class="text-red-500 text-sm border p-2 rounded">
            Tipo de parámetro no reconocido: "{{ item.tipo?.comaNombrecorto }}"
          </div>
        </div>
        <div class="col-span-4">
          <ButtonDefault @click="aplicarCambios(parametros)">Guardar</ButtonDefault>
        </div>
      </div>
    </div>
</template>
<script setup lang="ts">
import type { IConfDocjsonparametrosForm } from '../../interfaces/tablas/IConfDocjsonparametros';

defineProps<{
   parametros: IConfDocjsonparametrosForm[]
   aplicarCambios: (parametros: IConfDocjsonparametrosForm[]) => void
}>()
</script>